import { useCallback, useState } from 'react';

const oldSchoolCopy = (text: string) => {
  const tempTextArea = document.createElement('textarea');
  tempTextArea.value = text;
  document.body.appendChild(tempTextArea);
  tempTextArea.select();
  document.execCommand('copy');
  document.body.removeChild(tempTextArea);
};

type CopyFn = (value: string) => void;

export const useCopyToClipboard = (): [string | null, CopyFn] => {
  const [state, setState] = useState<string | null>(null);

  const copyToClipboard = useCallback<CopyFn>((value) => {
    const handleCopy = async () => {
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(value);
          setState(value);
        } else {
          throw new Error('writeText not supported');
        }
      } catch {
        oldSchoolCopy(value);
        setState(value);
      }
    };

    handleCopy();
  }, []);

  return [state, copyToClipboard];
};
